export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13244.d6c2838a.jpg";